import React, { useContext } from "react";
import { Table, Thead, Tbody, Tr, Td } from "@chakra-ui/react";
import { colours } from "@/utils/themeUtils";
import { ScheduleRule, ScheduleTableRow } from "./ScheduleTableRow";
import { TableContainer, Th } from "../ui/Table";
import { ScheduleTableContext } from ".";
import { sortScheduleRules } from "./utils";

interface Props {
	classroomId: string;
	scheduleRules: ScheduleRule[];
}

export function ScheduleTable(props: Props): JSX.Element {
	const { showNewScheduleRow, duplicateSchedule } = useContext(ScheduleTableContext);

	return (
		<TableContainer>
			<Table variant={"qoriaStriped"}>
				<Thead>
					<Tr>
						<Th px={4}>Day</Th>
						<Th px={4}>Start time</Th>
						<Th px={4}>End time</Th>
						<Th px={4}>End date</Th>
						<Th px={4} textAlign="center">
							Active
						</Th>
					</Tr>
				</Thead>
				<Tbody>
					{showNewScheduleRow && <ScheduleTableRow isNewSchedule={true} classroomId={props.classroomId} schedule={duplicateSchedule} />}
					{!showNewScheduleRow && props.scheduleRules.length === 0 ? (
						<Tr>
							<Td colSpan={5} textAlign="center" py={8} color={colours.navy[700]}>
								No schedules found
							</Td>
						</Tr>
					) : (
						sortScheduleRules(props.scheduleRules).map((schedule) => (
							<ScheduleTableRow key={schedule.id} isNewSchedule={false} schedule={schedule} classroomId={props.classroomId} />
						))
					)}
				</Tbody>
			</Table>
		</TableContainer>
	);
}
